import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from 'src/assets/tailwind/x-close.svg';
import { Button } from 'src/components/ui/button';
import { Typography } from 'src/components/ui/typography';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

type NotificationPanelHeaderProps = {
  onClose?: () => void;
};

const NotificationPanelHeader = ({ onClose }: NotificationPanelHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="tw:flex tw:items-center tw:justify-between tw:px-m tw:py-s">
      <Typography variant="h3" colorClass="tw:text-text-primary" weight="regular">
        {t(T.notifications)}
      </Typography>
      <Button
        iconOnly
        size="small"
        hierarchy="ghost"
        leftIcon={CloseIcon}
        onClick={onClose}
        aria-label={t(T.closeNotifications)}
      />
    </div>
  );
};

export default NotificationPanelHeader;
